
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.19 94.19"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"47.1","cy":"47.1","r":"47.1","fill":"#cad3e0"}}),_c('path',{attrs:{"d":"M25.08 40.23h7.9v2.37h-5.34v2.17h5.04v2.37h-5.04v2.37h5.64v2.37h-8.2V40.23zm10.26 0h3.48l4.95 8.08h.03v-8.08h2.56v11.63h-3.35l-5.08-8.28h-.03v8.28h-2.56V40.23zm13.4 0h3.85c3.75 0 6.89 1.59 6.89 5.85 0 3.76-3.07 5.79-6.54 5.79h-4.19V40.23zm2.56 9.27h1.33c2.38 0 4.17-.9 4.17-3.55 0-2.28-1.82-3.35-3.99-3.35H51.3v6.9zm10.02-9.27h7.9v2.37h-5.34v2.17h5.04v2.37h-5.04v2.37h5.64v2.37h-8.2V40.23z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"47.1","cy":"47.1","r":"34.76","fill":"none","stroke":"#fff","stroke-width":"6","stroke-miterlimit":"10"}})])
          )
        }
      }
    